import React, { createContext, useState } from "react";

const PopUpContext = createContext();

function PopUpProvider( { children } ) {
    const [popUp, setPopUp] = useState( null );

    return (
        <PopUpContext.Provider value={ { popUp, setPopUp } }>
            { children }
        </PopUpContext.Provider>
    );
}

export {
    PopUpContext,
    PopUpProvider,
}